/*global ClipboardJS */

var linkBuilder = {
    init: function() {
        var options = {
            disable_search: true,
            inherit_select_classes: true,
            width: '100%'
        };

        $('#pick-language').chosen(options).on('change', function() {
            linkBuilder.generateUrl();
        });

        var copyLink = new ClipboardJS('.btn-copy');

        copyLink.on('success', function(event) {
            event.clearSelection();
            event.trigger.textContent = _d.t.copied;
            window.setTimeout(function() {
                event.trigger.textContent = _d.t.copy;
            }, 2000);
        });

        $('#generateLink').on('click', function(e) {
            e.preventDefault();

            linkBuilder.generateUrl();
            $('.clipboard').slideDown();
            $('#generateLink').removeClass('loading');
        });

        $('#addCode').on('keyup', function() {
            linkBuilder.generateUrl();
        });
    },
    generateUrl: function() {
        var lang = $('#pick-language').chosen().val() || '',
            country = $('#countryUrl').val(),
            city = $('#cityUrl').val(),
            location = $('#locationUrl').val(),
            addCode = $('#addCode').val() || '',
            url = _d.url.host + (lang !== 'en' ? '/' + lang : '') + (country.length > 0 ? '/' + country : '') + (city.length > 0 ? '/' + city : '') + (location.length > 0 && location !== 'undefined' ? '/' + location : '') + (addCode.length > 0 ? '?a_aid=' + addCode : '');

        $('#copyLink').text(url).attr('href', url);
    }
};
